export const cdp = {
	tabs: {
		dashboard: "Visão geral",
		customers: "Lista de Clientes",
		rfmAnalysis: "Comportamento de clientes",
		segments: "Segmentos",
	},
	common: {
		loading: "Carregando...",
	},
	header: {
		title: "Painel CRM",
		subtitle:
			"Conheça, acompanhe e ative sua base de clientes, transformando dados em campanhas e vendas",
	},
	rfm: {
		labels: {
			champions: "Campeões",
			loyal: "Leais",
			highPotential: "Alto Potencial",
			promising: "Promissores",
			recent: "Recentes",
			attention: "Atenção",
			canNotLose: "Não Pode Perder",
			risk: "Em Risco",
			closeToHibernation: "Próximo de Hibernar",
			hibernating: "Hibernando",
			lost: "Perdidos",
		},
		descriptions: {
			champions: "Compraram há pouco, vêm com frequência e gastam muito",
			loyal: "Voltam com boa frequência e compraram recentemente",
			highPotential: "Compraram há pouco com bom gasto — quase fiéis",
			promising: "Compra recente com bons sinais de frequência e gasto",
			recent: "Compraram há pouco, mas ainda com poucas visitas",
			attention: "Recência mediana — precisam de estímulo para voltar",
			canNotLose: "Gastavam muito, mas não compram há muito tempo",
			risk: "Já compraram bem, mas estão esfriando há tempo",
			closeToHibernation: "Recência e frequência baixas — quase inativos",
			hibernating: "Compras antigas, com frequência e gasto baixos",
			lost: "Compraram pouco, gastaram pouco e não voltaram",
		},
	},
	dashboard: {
		title: "Painel CDP",
		subtitle:
			"Acompanhe seus clientes, métricas de relacionamento e segmentação inteligente",
		filters: {
			period: {
				label: "Período",
				options: {
					last7Days: "Últimos 7 dias",
					last15Days: "Últimos 15 dias",
					last30Days: "Últimos 30 dias",
					last60Days: "Últimos 60 dias",
					last90Days: "Últimos 90 dias",
				},
			},
			groupBy: {
				label: "Agrupar por",
				options: {
					week: "Semana",
					month: "Mês",
				},
			},
			establishments: {
				label: "Estabelecimentos",
				all: "Todos",
			},
			apply: "Filtrar",
		},
		advanced: {
			top10Title: "Top 10 Clientes por Valor",
			noClients: "Nenhum cliente encontrado",
			visitsPerMonth: "visitas/mês",
			viewTop100: "Ver melhores clientes",
			sectionTitle: "Análises Avançadas",
			sectionSubtitle: "Visualização detalhada do valor dos clientes",
			rankingTitle: "Top {{count}} Clientes por Valor",
			viewMore: "Ver mais",
			viewLess: "Ver menos",
		},
		alerts: {
			title: "Alertas e Riscos",
			subtitle: "Indicadores de atenção para sua base de clientes",
			cards: {
				inactive: {
					title: "Clientes Inativos",
					label: "Inativos há 90+ dias",
					tooltip: "Considera os últimos 90 dias a partir de hoje.",
					ofBase: "da base",
					anomalyTooltip:
						"O percentual de inativos excede 100% da base ativa. Isso pode indicar inconsistência nos dados — clientes podem estar sendo contados em múltiplos locais ou o total da base não inclui todos os clientes históricos.",
				},
				balance: {
					title: "Créditos Disponíveis",
					tooltip:
						"Saldo de recargas que os clientes carregaram e ainda não gastaram (desconsidera recargas reembolsadas ou expiradas). É dinheiro parado na casa — um bom motivo para chamar esses clientes de volta.",
					clients: "Clientes",
					percentOfBase: "% da base",
					averagePerClient: "Média/cliente",
				},
				churn: {
					title: "Clientes em Risco de Churn",
				},
			},
		},
		demographics: {
			title: "Análise Demográfica",
			subtitle: "Perfil demográfico da sua base de clientes",
			genderTitle: "Distribuição por Gênero",
			ageTitle: "Distribuição por Faixa Etária",
			ageMissingBirthDate:
				"⚠ {{percentage}}% dos clientes não têm data de nascimento informada e ficam de fora",
			genders: {
				male: "Masculino",
				female: "Feminino",
				other: "Outro",
				notInformed: "Não informado",
			},
		},
		evolution: {
			title: "Evolução Temporal",
			subtitle: "Acompanhe a evolução das métricas ao longo do tempo",
			yAxisClients: "Clientes",
			referenceAverage: "Média",
			clientsTooltip: "{{value}} clientes",
			activeBase: {
				title: "Evolução da Base Ativa",
				subtitle: "Clientes únicos por período",
			},
			averageTicket: {
				title: "Evolução de Ticket Médio",
				subtitle: "Valor médio por visita",
			},
			newVsRecurring: {
				title: "Novos vs. Recorrentes",
				subtitle: "Composição da base ao longo do tempo",
				newClients: "Novos",
				recurringClients: "Recorrentes",
			},
			activation: {
				title: "Taxa de Ativação ao Longo do Tempo",
				subtitle:
					"Conversão de novos em recorrentes · janela móvel de 180 dias · vs. mesmo período do ano anterior",
				currentSeries: "Atual",
				previousSeries: "Ano anterior",
			},
		},
		health: {
			title: "Saúde da Base",
			subtitle: "Visão geral dos principais indicadores de clientes",
			variationTooltip: "Variação em relação ao período anterior",
			activeClients: {
				label: "Clientes Ativos",
				subLabel: "Clientes únicos no período",
				tooltip:
					"Clientes identificados (CPF/telefone) com ao menos uma interação no período selecionado",
			},
			averageTicket: {
				label: "Ticket Médio",
				subLabel: "Valor médio por visita",
			},
			activationRate: {
				label: "Taxa de Ativação",
				subLabel: "Conversão de novos em recorrentes",
				tooltip: "Percentual de novos clientes que voltaram para uma segunda visita",
				variationSuffix: " p.p.",
			},
			reactivated: {
				label: "Clientes Reativados",
				subLabel: "Inativos que voltaram",
				tooltip: "Clientes que estavam inativos (>30 dias) e retornaram no período",
			},
			interval: {
				label: "Intervalo Médio",
				subLabel: "Dias entre visitas",
				tooltip: "Quanto menor, melhor - indica maior engajamento",
				daysValue: "{{days}} dias",
			},
		},
		rfmSection: {
			sectionTitle: "Análise de Clientes",
			sectionSubtitle: "Distribuição da base por classificação RFM",
			chartTitle: "Distribuição RFM",
			chartSubtitle:
				"Distribuição da base completa · clique em um segmento para ver detalhes · ordene pelas colunas",
		},
		rfmDistribution: {
			columns: {
				name: "Classificação",
				percentage: "% da base",
				count: "Clientes",
				averageTicket: "Ticket médio",
				totalTpv: "TPV",
			},
			rowTitle: "Ver clientes deste segmento",
		},
		segmentsSection: {
			title: "Segmentos Customizados",
			emptySubtitle: "Agrupe clientes por comportamento e acompanhe seus indicadores",
			emptyTitle: "Nenhum segmento customizado encontrado",
			emptyText:
				'Crie segmentos para agrupar clientes por comportamento — por exemplo "VIPs" ou "Sumidos com saldo" — e acompanhe os números de cada grupo aqui no painel.',
			createButton: "Criar segmento",
			subtitle: "Clique em um segmento para ver os clientes",
			columnName: "Nome do Segmento",
			columnCount: "Clientes",
			columnPercentage: "% Base",
			columnAverageTicket: "Ticket Médio",
			columnActions: "Ações",
			editSegment: "Editar segmento",
			deleteSegment: "Excluir segmento",
		},
		mixClients: {
			title: "Mix de Clientes",
			new: "Novos",
			recurring: "Recorrentes",
			reactivated: "Reativados",
		},
		valueMatrix: {
			loading: "Carregando…",
			noData: "Sem dados no período.",
			title: "Concentração de clientes",
			total: "Total: {{total}} clientes",
			yAxisTitle: "ticket médio (R$)",
			xAxisTitle: "média de visitas/mês",
			cellTitle: "{{ticket}}  ·  {{frequency}} visitas/mês: {{clients}} clientes",
		},
	},
	customers: {
		title: "Lista de Clientes",
		subtitle: "Busque e filtre clientes da sua base",
		globalFilters: {
			placeLabel: "Local",
			placePlaceholder: "Todas as casas",
			searchPlaceholder: "Buscar...",
			noResults: "Nenhum resultado",
			baseLabel: "Base considerada",
			baseOptions: {
				all: "Toda a base",
				last90Days: "Últimos 90 dias",
				last180Days: "Últimos 180 dias",
				last365Days: "Últimos 365 dias",
			},
		},
		relativeTime: {
			today: "hoje",
			daysAgo_one: "há {{count}} dia",
			daysAgo_other: "há {{count}} dias",
			monthsAgo_one: "há {{count}} mês",
			monthsAgo_other: "há {{count}} meses",
			yearsAgo_one: "há {{count}} ano",
			yearsAgo_other: "há {{count}} anos",
		},
		classificationView: {
			label: "Classificação do cliente:",
			all: "Todas as casas",
			best: "Apenas a melhor",
		},
		filters: {
			removePill: "Remover {{label}}",
			search: {
				label: "Buscar",
				placeholder: "Buscar por nome, email, telefone ou documento...",
			},
			listSearch: {
				placeholder: "Buscar...",
				noResults: "Nenhum resultado",
			},
			place: {
				label: "Local",
				placeholder: "Todos os locais",
				selectedCount: "{{count}} selecionados",
			},
			rfmClassification: {
				label: "Classificação RFM",
				placeholder: "Todas as classificações",
				selectedCount: "{{count}} selecionadas",
			},
			clientClassification: {
				label: "Classificação RFM multi-casa",
				tooltip:
					"Quando o cliente visitou várias casas e possui classificações diferentes, este filtro define qual classificação é exibida.",
				all: "Mostrar todas as classificações",
				best: "Mostrar só a melhor",
			},
			segments: {
				label: "Segmentos",
				placeholder: "Todos os segmentos",
				selectedCount: "{{count}} selecionados",
			},
			allowCommunication: {
				label: "Permite Comunicação",
				all: "Todos",
				yes: "Sim",
				no: "Não",
			},
			status: {
				label: "Status",
				placeholder: "Todos os status",
				selectedCount: "{{count}} selecionados",
			},
			gender: {
				label: "Gênero",
				placeholder: "Todos os gêneros",
				selectedCount: "{{count}} selecionados",
				male: "Masculino",
				female: "Feminino",
				other: "Outro",
			},
			lastInteraction: {
				label: "Última Interação",
				placeholder: "Qualquer data",
				last7Days: "Últimos 7 dias",
				last30Days: "Últimos 30 dias",
				last60Days: "Últimos 60 dias",
				last90Days: "Últimos 90 dias",
				moreThan90Days: "Mais de 90 dias",
				custom: "Personalizado",
			},
			activityPeriod: {
				label: "Período de Atividade",
				from: "De",
				to: "Até",
				lastDays: "Últimos {{count}} dias",
				shortcutsLabel: "Últimos:",
			},
			balance: {
				label: "Saldo Disponível",
				onlyWithBalance: "Somente com saldo",
				minBalance: "Saldo mínimo (R$)",
			},
			consumptionMin: {
				label: "Consumo mínimo (R$)",
				placeholder: "Ex.: 100",
			},
			avgTicketMin: {
				label: "Ticket médio mínimo (R$)",
				placeholder: "Ex.: 50",
			},
			presences: {
				label: "Mínimo de visitas",
				labelTotal: "Mínimo de visitas (total)",
				any: "Qualquer",
				option: "{{count}}+ visitas",
				placeholder: "Ex.: 3",
			},
			birthday: {
				label: "Período de aniversário",
				from: "De",
				to: "Até",
				shortcutsLabel: "Sugestões:",
				thisMonth: "Esse mês",
				nextMonth: "Próximo mês",
				invalidDate: "Data inválida.",
				dayColumn: "Dia",
				monthColumn: "Mês",
			},
			birthYear: {
				label: "Idade",
				modeAge: "Idade",
				modeYear: "Ano",
				yearLabel: "Ano de nascimento",
				from: "De",
				to: "Até",
			},
			rangeError: "“Até” deve ser maior que “De”.",
			product: {
				label: "Produto",
				placeholder: "Todos os produtos",
				selectedCount: "{{count}} selecionados",
			},
			sections: {
				activity: "Atividade e consumo",
				demographics: "Demografia",
			},
			advanced: {
				show: "Mais filtros",
				hide: "Menos filtros",
				drawerButton: "Filtros",
				drawerTitle: "Filtros da lista",
				drawerApply: "Ver {{value}} clientes",
				sectionDemographics: "Demografia",
				sectionActivity: "Consumo",
				sectionStatus: "Status",
			},
			actions: {
				apply: "Aplicar Filtros",
				clear: "Limpar Filtros",
			},
			results: "{{value}} clientes encontrados",
			searching: "Buscando clientes...",
			segmentMerge: {
				eyebrow: "Segmento",
				hint:
					"As regras de cada segmento preenchem os filtros abaixo. Você pode refinar à vontade.",
				appliedTitle: "Filtros aplicados",
				appliedByOne: "vindos de 1 segmento",
				appliedByMany: "vindos de {{count}} segmentos",
				editableBadge: "editável",
				markerApplied: "Segmento aplicado",
				markerCombined: "Segmento combinado",
				markerAdjusted: "Segmento ajustado",
				appliedFrom: "Este filtro vem do segmento {{segment}}.",
				appliedActivity:
					"Ativos nos últimos {{days}} dias — definido pelo segmento {{segments}}.",
				combinedFrom: "Este filtro une os segmentos: {{segments}}.",
				combinedWithManual: "Une os segmentos {{segments}} mais a sua seleção manual.",
				conflictMsg:
					"Mais de um segmento define este filtro. Vale o do último selecionado: {{used}} ({{usedValue}}).",
				activityAdjusted:
					"Os segmentos usam janelas diferentes. Usamos a maior — {{days}} dias.",
			},
		},
		table: {
			columns: {
				name: "Cliente",
				contact: "Contato",
				cpf: "CPF",
				classification: "Classificação",
				behavior: "Comportamento",
				birthDate: "Aniversário",
				firstVisit: "1ª vez",
				totalPaid: "Total pago",
				averageTicket: "Tkt Médio",
				balance: "Saldo disponível",
				hasApp: "Aplicativo ativo",
				actions: "Ações",
			},
			visits: "{{count}} visitas",
			lastVisit: "Última visita",
			classificationPlace: "{{places}}",
			classificationPlaces: "{{places}}",
			uninformed: "Não informado",
			appActive: "Sim",
			appInactive: "Não",
			hasAppTitle: "Aplicativo ativo",
			balanceShort: "Saldo",
			firstVisitShort: "Primeira visita",
			lastVisitShort: "Última visita",
			noName: "Sem nome",
			ago: "há {{days}} dias",
			totalPaid: "Total pago",
			averageTicket: "Ticket médio",
			balance: "Saldo",
			viewDetails: "Ver Detalhes",
			details: "Detalhes",
			noResults: "Nenhum cliente encontrado",
			noResultsDescription: "Tente ajustar os filtros para encontrar clientes",
		},
		status: {
			active: "Ativo",
			attention: "Atenção",
			risk: "Risco",
			inactive: "Inativo",
		},
		drawer: {
			title: "Detalhes do Cliente",
			noName: "Sem nome",
			tabs: {
				summary: "Resumo",
				favoriteProducts: "Produtos Favoritos",
				history: "Histórico",
				purchases: "Visitas",
			},
			summary: {
				personalData: "Dados Pessoais",
				document: "Documento",
				email: "Email",
				phone: "Telefone",
				birthDate: "Nascimento",
				ageYears: "{{age}} anos",
				gender: "Gênero",
				city: "Cidade",
				location: "Local",
				preferences: "Preferências",
				allowsCommunication: "Permite Comunicação",
				communicationDenied: "Não permite comunicação",
				appInstalled: "App instalado",
				noApp: "Sem app",
				activitySummary: "Resumo de Atividade",
				firstVisit: "Primeira Visita",
				lastVisit: "Última Visita",
				totalVisits: "Total de Visitas",
				averageFrequency: "Frequência Média",
				visitsPerMonth: "visitas/mês",
				customerFor: "Dias como cliente",
				financial: "Financeiro",
				totalPaid: "Total Pago",
				averageTicket: "Ticket Médio",
				availableBalance: "Saldo Disponível",
				classifications: "Classificações",
				rfmByPlace: "RFM por Estabelecimento",
				segments: "Segmentos",
			},
			products: {
				product: "Produto",
				category: "Categoria",
				quantity: "Quantidade",
				totalValue: "Valor Total",
				lastPurchase: "Última Compra",
				top10: "Top 10 Produtos",
				sortByQuantity: "Por quantidade",
				sortByValue: "Por valor",
				noProducts: "Nenhum produto favorito encontrado",
			},
			history: {
				filterByType: "Filtrar por tipo",
				allTypes: "Todos os tipos",
				loadMore: "Carregar mais",
				noHistory: "Nenhum histórico encontrado",
				noPlace: "Sem estabelecimento",
				unknownPlace: "Outro estabelecimento",
				interaction: "visita",
				interactions: "visitas",
				firstShort: "1ª:",
				lastShort: "última:",
				items: "itens",
			},
			purchases: {
				product: "Produto",
				category: "Categoria",
				quantity: "Qtd",
				unitPrice: "Preço Unit.",
				total: "Total",
				date: "Data",
				noPurchases: "Nenhuma compra encontrada",
				loadMore: "Carregar mais",
				visitTotal: "Total da visita",
				visitNoItems: "Sem consumo registrado",
				unitSuffix: "un.",
				discount: "Desconto",
				noPlace: "Sem estabelecimento",
				unknownPlace: "Outro estabelecimento",
				loadingMore: "Carregando mais visitas…",
			},
			actions: {
				close: "Fechar",
				addToSegment: "Adicionar a Segmento",
				edit: "Editar",
			},
		},
		genders: {
			male: "Masculino",
			female: "Feminino",
			other: "Outro",
			unknown: "Não informado",
		},
		interactionTypes: {
			presence: "Presença",
			recharge: "Recarga",
			giftbackRescue: "Resgate Giftback",
			giftbackExpire: "Expiração Giftback",
			giftbackReceive: "Recebimento Giftback",
			ticketPurchase: "Compra Ingresso",
			ticketCancel: "Cancelamento Ingresso",
			communication: "Comunicação",
			rfmMigration: "Migração RFM",
		},
		labels: {
			status: {
				active: "Ativo",
				attention: "Atenção",
				risk: "Risco",
				inactive: "Inativo",
			},
			interaction: {
				Event: "Evento",
				TicketOrder: "Pedido de Ingresso",
				NpsSurveyAnswer: "Resposta NPS",
				Communication: "Comunicação",
				SegmentAlteration: "Alteração de Segmento",
			},
		},
	},
	segments: {
		title: "Segmentos",
		subtitle: "Crie e gerencie segmentos customizados de clientes",
		summary: {
			highestRevenue: "Segmento com maior receita",
			highestTicket: "Segmento com maior ticket médio",
			mostCustomers: "Segmento com mais clientes",
			leastCustomers: "Segmento com menos clientes",
		},
		search: {
			placeholder: "Buscar segmento...",
		},
		actions: {
			create: "Criar segmentação",
			edit: "Editar",
			delete: "Excluir",
			duplicate: "Duplicar",
		},
		card: {
			createdBy: "Criado por: {{name}}",
			leads: "{{count}} leads",
			metrics: {
				clients: "Clientes",
				revenue: "Receita",
				avgTicket: "Ticket médio",
				baseShare: "% da base",
			},
			lastSync: "Última sincronização: {{date}}",
			neverSynced: "Nunca sincronizado",
			syncStatus: {
				synced: "Sincronizado",
				outdated: "Desatualizado",
				outdatedTooltip:
					"O segmento foi alterado após a última sincronização e precisa ser reprocessado.",
				neverTooltip: "Este segmento ainda não foi sincronizado.",
			},
		},
		drawer: {
			titleCreate: "Criar segmento",
			titleEdit: "Editar segmento",
			fields: {
				name: "Nome",
				namePlaceholder: "Nome do segmento",
				description: "Descrição",
				descriptionPlaceholder: "Descreva o objetivo deste segmento",
				analysisPeriod: "Ativos nos últimos N dias",
				analysisPeriodPlaceholder: "Ex: 30 (vazio = qualquer)",
				analysisPeriodShortcuts: "Sugestões:",
			},
			rules: {
				title: "Regras de Segmentação",
				demographic: "Demográficas",
				consumption: "Consumo",
				engagement: "Engajamento",
				status: "Status",
				gender: {
					label: "Gênero",
					placeholder: "Selecione os gêneros",
					male: "Masculino",
					female: "Feminino",
					other: "Outro",
				},
				birthday: {
					label: "Aniversário (dia/mês)",
					from: "De",
					to: "Até",
					shortcutsLabel: "Sugestões:",
					thisMonth: "Esse mês",
					nextMonth: "Próximo mês",
					invalidDate: "Data inválida.",
				},
				birthYear: {
					label: "Idade",
					modeAge: "Idade",
					modeYear: "Ano",
					yearLabel: "Ano de nascimento",
					from: "De",
					to: "Até",
				},
				rangeError: "“Até” deve ser maior que “De”.",
				listSearch: {
					placeholder: "Buscar...",
					noResults: "Nenhum resultado",
				},
				minPresences: {
					label: "Visitas mínimas",
					placeholder: "Mínimo de visitas no período",
				},
				minTotalPaid: {
					label: "Valor total mínimo",
					placeholder: "R$ 0,00",
					tooltip:
						"Valor mínimo acumulado gasto pelo cliente no período de análise definido. Apenas clientes com gasto total igual ou superior a este valor serão incluídos no segmento.",
				},
				minAvgTicket: {
					label: "Ticket médio mínimo",
					placeholder: "R$ 0,00",
				},
				minRemainingBalance: {
					label: "Saldo mínimo disponível",
					placeholder: "R$ 0,00",
				},
				rfmClassification: {
					label: "Classificação RFM",
					placeholder: "Selecione as classificações",
				},
				allowCommunication: {
					label: "Permite comunicação",
					any: "Qualquer",
					yes: "Sim",
					no: "Não",
				},
			},
			actions: {
				save: "Salvar",
				cancel: "Cancelar",
				saving: "Salvando...",
			},
			validation: {
				nameRequired: "Nome é obrigatório",
				descriptionRequired: "Descrição é obrigatória",
				analysisPeriodRequired: "Período de análise é obrigatório",
				analysisPeriodMin: "Período deve ser maior que 0",
			},
		},
		deleteModal: {
			title: "Excluir segmento",
			message:
				'Tem certeza que deseja excluir o segmento "{{name}}"? Esta ação não pode ser desfeita.',
			confirm: "Excluir",
			cancel: "Cancelar",
			deleting: "Excluindo...",
		},
		empty: {
			title: "Nenhum segmento encontrado",
			description: "Crie seu primeiro segmento para começar a organizar seus clientes.",
			searchEmpty: "Nenhum segmento corresponde à sua busca.",
		},
		toast: {
			createSuccess: "Segmento criado com sucesso",
			updateSuccess: "Segmento atualizado com sucesso",
			deleteSuccess: "Segmento excluído com sucesso",
		},
	},
	rfmAnalysis: {
		title: "Análise RFM",
		subtitle: "Análise de Recência, Frequência e Valor Monetário dos clientes",
		configButton: "Configurar parâmetros",
		rangesButton: "Réguas de classificação",
		countingNote:
			"Contagem por casa: cliente com classificações diferentes entre casas conta em cada uma delas — a soma das classes pode exceder o nº de clientes únicos.",
		viewModes: {
			simplified: "Simplificado",
			detailed: "Detalhado",
		},
		filters: {
			establishment: "Estabelecimento",
			allEstablishments: "Todos os estabelecimentos",
			period: "Período",
			groupBy: "Agrupar por",
			periods: {
				last7Days: "Últimos 7 dias",
				last15Days: "Últimos 15 dias",
				last30Days: "Últimos 30 dias",
				last60Days: "Últimos 60 dias",
				last90Days: "Últimos 90 dias",
			},
			groupByOptions: {
				week: "Por semana",
				month: "Por mês",
			},
		},
		charts: {
			distributionTitle: "Quantidade por Status RFM ao Longo do Tempo",
			distributionSubtitle: "Evolução da distribuição de clientes",
			donutTitle: "Distribuição de Clientes",
			donutSubtitle: "Segmentação por classificação RFM",
			treemapTitle: "Distribuição RFM",
			treemapSubtitle: "Clique em um segmento para ver detalhes",
			stackedAreaTitle: "Composição da Base ao Longo do Tempo",
			stackedAreaSubtitle: "Evolução dos segmentos RFM",
			total: "Total",
			clients: "clientes",
			visible: "Visível",
			donutTooltip: "{{value}} clientes ({{percentage}}%)",
		},
		table: {
			title: "Detalhamento por Classificação RFM",
			subtitle: "Métricas detalhadas de cada segmento",
			columns: {
				classification: "Classificação",
				clients: "Clientes",
				percentBase: "% Base",
				totalTpv: "TPV Total",
				percentTpv: "% TPV",
				averageTicket: "Ticket Médio",
			},
			total: "Total",
			noData: "Nenhum dado disponível para o período selecionado",
			rowTitle: "Ver clientes deste segmento",
			showInChart: "Clique para exibir no gráfico",
			hideFromChart: "Clique para ocultar do gráfico",
		},
		cards: {
			averageTicket: "Ticket Médio",
		},
		summaryCards: {
			groupTitle: "Ver clientes deste grupo",
		},
		groups: {
			fieis: "Clientes ótimos",
			promissores: "Clientes bons",
			emRisco: "Clientes em alerta",
			perdidos: "Clientes em estado crítico",
		},
		quintileRanges: {
			title: "Réguas de classificação",
			subtitle:
				"Faixas de Recência, Frequência e Ticket usadas para classificar os clientes desta casa (quintis calculados sobre a base ativa da própria casa)",
			placePlaceholder: "Estabelecimento",
			searchPlaceholder: "Buscar...",
			noResults: "Nenhum resultado",
			columnClassification: "Classificação",
			columnRecency: "Recência (última visita)",
			columnFrequency: "Frequência (visitas)",
			columnTicket: "Ticket médio por visita",
			footnoteMain:
				"Faixas recalculadas diariamente a partir do comportamento da própria casa",
			footnoteReference: " (referência: {{date}})",
			footnoteLegend: ". “—” = faixa não atingível nesta casa (pouca variação na base).",
			ranges: {
				empty: "—",
				recencyAny: "qualquer recência",
				recencyUpTo: "até {{value}} dias",
				recencyMoreThan: "mais de {{value}} dias",
				recencyExact: "{{value}} dias",
				recencyBetween: "de {{min}} a {{max}} dias",
				frequencyAny: "qualquer nº de visitas",
				frequencySingle: "1 visita",
				frequencyUpTo: "até {{value}} visitas",
				frequencyAtLeast: "{{value}}+ visitas",
				frequencyExact_one: "{{value}} visita",
				frequencyExact_other: "{{value}} visitas",
				frequencyBetween: "de {{min}} a {{max}} visitas",
				ticketAny: "qualquer ticket",
				ticketUpTo: "até {{value}}",
				ticketAbove: "acima de {{value}}",
				ticketBetween: "de {{lower}} até {{upper}}",
			},
		},
		treemap: {
			clients: "clientes",
			ofBase: "da base",
			averageTicketLabel: "Ticket médio",
			noData: "Sem dados no período.",
		},
		configModal: {
			title: "Configurar Parâmetros RFM",
			warning:
				"Alterar as regras RFM irá recalcular a classificação de todos os clientes. Esta operação pode levar alguns minutos para ser processada.",
			resetButton: "Restaurar Padrão",
			cancelButton: "Cancelar",
			saveButton: "Salvar Configuração",
			savingButton: "Salvando...",
		},
		errors: {
			loadTitle: "Erro ao carregar dados",
			loadText:
				"Não foi possível carregar os dados da análise RFM. Por favor, tente novamente.",
			retryButton: "Tentar novamente",
		},
		empty: {
			title: "Sem dados para exibir",
			text:
				"Não há dados suficientes para gerar a análise RFM no período selecionado. Tente selecionar um período maior ou aguarde mais interações dos clientes.",
		},
		toast: {
			saveSuccess: "Configuração RFM salva com sucesso",
			saveError: "Erro ao salvar configuração RFM",
			resetSuccess: "Configuração RFM restaurada ao padrão",
		},
	},
};
